import { render } from "./ListCreatePanelV2.vue?vue&type=template&id=603eee20&scoped=true"
import script from "./ListCreatePanelV2.vue?vue&type=script&lang=ts"
export * from "./ListCreatePanelV2.vue?vue&type=script&lang=ts"

import "./ListCreatePanelV2.vue?vue&type=style&index=0&id=603eee20&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-603eee20"

export default script